<script lang="ts">
  import { createEventDispatcher } from "svelte";
import { select_value } from "svelte/internal";
  import { Icon, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, TabContent, TabPane } from "sveltestrap";
  import { error, success } from "../../../../../public/my-theme";
  import type { Fn } from "../../../../global";
  import type { Complainant } from "../../../../Model/Complainant";
import type { ComplainantGender } from "../../../../Model/ComplainantGender";
  import type { ComplainantTraffic } from "../../../../Model/ComplainantTraffic";
  import type { Third } from "../../../../Model/Third";
  import { complainantGenderService, complainantService } from "../../../../services";
  import AddVehicleList from "../../../AddVehicleList.svelte";
  import DateLocalInput from "../../../DateLocalInput.svelte";
  import ParamSelect from "../../../ParamSelect.svelte";
  import VehicleInput from "../../../VehicleInput.svelte";
  import ComplaintInfoForm from "../../ComplaintInfoForm.svelte";

  export let complainantThird: Third;
  export let diligenceId: string;
  export let open = false;
  export let toggle: Fn = undefined;

  $: load(diligenceId, complainantThird)

  let size = "lg";
  let editVehicle: boolean = false;
  let complainant: Complainant;
  let complainantGender: ComplainantGender;

  const dispatch = createEventDispatcher();

  async function load(diligenceId, complainantThird){
    if (diligenceId && complainantThird) {

      let complainants: Complainant[] = await complainantService.findByDiligenceNumber(diligenceId)
      complainant = complainants.find(c => c.complainantThirId == complainantThird.id)

      if (complainant) {

        complainantGender = await complainantGenderService.findOneByDiligenceNumber(complainant.diligenceNumber);

      }

    }
  }

  async function saveComplainantTraffic() {
    try {
      save()
      toggle()
      success("Datos guardados con exito");
    } catch (err) {
      error("Comprueba los campos");
    }
  }

  async function changeThirdList(third){
    complainant.complainantThirId = third.id;
    complainantGender.complainantThirId = third.id;
    save()
  }

  async function save(){
    await Promise.all([ 
      complainantService.saveComplainant(complainant),
      complainantGenderService.saveComplainantTraffic(complainantGender)
    ])

    dispatch('saveComplainant');
  }


</script>

<Modal isOpen={open} {toggle} {size}>
  <ModalHeader {toggle}>Editar</ModalHeader>
  <ModalBody>

    <TabContent>
      <TabPane tabId="Datos" tab="Datos" active>
        {#if complainant}
          <ComplaintInfoForm complainant={complainant} on:changeThirdLIst={(event) => changeThirdList(event.detail)}/>
        {/if}
      </TabPane>
      {#if complainantGender}
      <TabPane tabId="1" tab="Asistencia">
        <div class="mt-3">
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="row">
                <div class="col-9 col-md-10">
                  Desea que el domicilio permanezca en secreto
                </div>
                <div class="col-3 col-md-2">
                  <Input
                    type="select"
                    id="secretAddress"
                    value={complainantGender.secretAddress ? 1 : 0}
                    on:change={(event) => {
                      complainantGender.secretAddress = Boolean(
                        select_value(event.target)
                      );
                    }}
                  >
                    <option value={1}>Si</option>
                    <option value={0}>No</option>
                  </Input>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="row">
                <div class="col-9 col-md-10">
                  Desea que su teléfono permanezca en secreto
                </div>
                <div class="col-3 col-md-2">
                  <Input
                    type="select"
                    id="secretPhone"
                    value={complainantGender.secretPhone ? 1 : 0}
                    on:change={(event) => {
                      complainantGender.secretPhone = Boolean(
                        select_value(event.target)
                      );
                    }}
                  >
                    <option value={1}>Si</option>
                    <option value={0}>No</option>
                  </Input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </TabPane>
      <TabPane tabId="2" tab="Asist. Jurídica">
        <div class="mt-3">
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="row">
                <div class="col-9 col-md-10 mb-3">
                  ¿Quiere un abogado que le asista?
                </div>
                <div class="col-3 col-md-2 mb-3">
                  <Input
                    type="select"
                    id="lawerToAssist"
                    value={complainantGender.lawerToAssist ? 1 : 0}
                    on:change={(event) => {
                      complainantGender.lawerToAssist = Boolean(
                        select_value(event.target)
                      );
                    }}
                  >
                    <option value={1}>Si</option>
                    <option value={0}>No</option>
                  </Input>
                </div>
                <div class="col-7 col-md-8 mb-3">
                  ¿Quiere el teléfono de un abogado?
                </div>
                <div class="col-5 col-md-4 mb-3">
                  <Input type="text" bind:value={complainantGender.lawyerPhone} />
               
                </div>
            </div>
          </div>
        </div>
      </TabPane>
      <!-- <TabPane tabId="3" tab="Sit. Legal">
        <div class="mt-3" />
      </TabPane> -->
      <TabPane tabId="4" tab="Sit. Familiar 1">
        <div class="mt-3">
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="row">
                <div class="col-9 col-md-10 mb-3">
                  ¿Ha denunciado con anterioridad a la misma persona?
                </div>
                <div class="col-3 col-md-2 mb-3">
                  <Input
                    type="select"
                    id="reportPreviousAttacker"
                    value={complainantGender.reportPreviousAttacker ? 1 : 0}
                    on:change={(event) => {
                      complainantGender.reportPreviousAttacker = Boolean(
                        select_value(event.target)
                      );
                      console.log(event.target);
                    }}
                  >
                    <option value={1}>Si</option>
                    <option value={0}>No</option>
                  </Input>
                </div>
                <div class="col-9 col-md-10 mb-3">
                  ¿Sabe si dicha persona tiene procedimiento judicial abierto
                  por delito o falta?
                </div>
                <div class="col-3 col-md-2 mb-3">
                  <Input
                    type="select"
                    id="openJudgmentAggressor"
                    value={complainantGender.openJudgmentAggressor ? 1 : 0}
                    on:change={(event) => {
                      complainantGender.openJudgmentAggressor = Boolean(
                        select_value(event.target)
                      );
                      console.log(event.target);
                    }}
                  >
                    <option value={1}>Si</option>
                    <option value={0}>No</option>
                  </Input>
                </div>
                <div class="col-9 col-md-10 mb-3">
                  ¿Convive con el agresor en el mismo domicilio?
                </div>
                <div class="col-3 col-md-2 mb-3">
                  <Input
                    type="select"
                    id="coexistsWithAggressor"
                    value={complainantGender.coexistsWithAggressor.toString()}
                    on:change={(event) => {
                      complainantGender.coexistsWithAggressor =
                        select_value(event.target) === "true";
                      console.log(event.target);
                    }}
                  >
                    <option value="true">Si</option>
                    <option value="false">No</option>
                  </Input>
                </div>
                <div class="col-9 col-md-10 mb-3">
                  ¿Quiere que el agresor abandone el domicilio para garantizar
                  su seguridad?
                </div>
                <div class="col-3 col-md-2 mb-3">
                  <Input
                    type="select"
                    id="abandonAggressorAddress"
                    value={complainantGender.abandonAggressorAddress ? 1 : 0}
                    on:change={(event) => {
                      complainantGender.abandonAggressorAddress = Boolean(
                        select_value(event.target)
                      );
                      console.log(event.target);
                    }}
                  >
                    <option value={1}>Si</option>
                    <option value={0}>No</option>
                  </Input>
                </div>
                <div class="col-9 col-md-10 mb-3">
                  ¿Quiere que se le prohiba al agresor acercársele?
                </div>
                <div class="col-3 col-md-2 mb-3">
                  <Input
                    type="select"
                    id="prohibitApproachingAggressor"
                    value={complainantGender.prohibitApproachingAggressor
                      ? 1
                      : 0}
                    on:change={(event) => {
                      complainantGender.prohibitApproachingAggressor = Boolean(
                        select_value(event.target)
                      );
                      console.log(event.target);
                    }}
                  >
                    <option value={1}>Si</option>
                    <option value={0}>No</option>
                  </Input>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 mb-3">
              <div class="row">
                <div class="col-9 col-md-10 mb-3">
                  ¿Quiere que se le prohiba al agresor que se comunique con
                  ella?
                </div>
                <div class="col-3 col-md-2 mb-3">
                  <Input
                    type="select"
                    id="prohibitCommunicatingAggressor"
                    value={complainantGender.prohibitCommunicatingAggressor
                      ? 1
                      : 0}
                    on:change={(event) => {
                      complainantGender.prohibitCommunicatingAggressor =
                        Boolean(select_value(event.target));
                      console.log(event.target);
                    }}
                  >
                    <option value={1}>Si</option>
                    <option value={0}>No</option>
                  </Input>
                </div>
                <div class="col-9 col-md-10 mb-3">
                  ¿Sabe si el agresor tiene armas?
                </div>
                <div class="col-3 col-md-2 mb-3">
                  <Input
                    type="select"
                    id="hasWeaponsAttacker"
                    value={complainantGender.hasWeaponsAttacker ? 1 : 0}
                    on:change={(event) => {
                      complainantGender.hasWeaponsAttacker = Boolean(
                        select_value(event.target)
                      );
                      console.log(event.target);
                    }}
                  >
                    <option value={1}>Si</option>
                    <option value={0}>No</option>
                  </Input>
                </div>
                <div class="col-9 col-md-10 mb-3">
                  ¿Desea abandonar el domicilio?
                </div>
                <div class="col-3 col-md-2 mb-3">
                  <Input
                    type="select"
                    id="abandonHome"
                    value={complainantGender.abandonHome ? 1 : 0}
                    on:change={(event) => {
                      complainantGender.abandonHome = Boolean(
                        select_value(event.target)
                      );
                      console.log(event.target);
                    }}
                  >
                    <option value={1}>Si</option>
                    <option value={0}>No</option>
                  </Input>
                </div>
                <div class="col-9 col-md-10 mb-3">
                  ¿Tiene familiares o amigos que le puedan acoger?
                </div>
                <div class="col-3 col-md-2 mb-3">
                  <Input
                    type="select"
                    id="hostPossibility"
                    value={complainantGender.hostPossibility ? 1 : 0}
                    on:change={(event) => {
                      complainantGender.hostPossibility = Boolean(
                        select_value(event.target)
                      );
                      console.log(event.target);
                    }}
                  >
                    <option value={1}>Si</option>
                    <option value={0}>No</option>
                  </Input>
                </div>
                <div class="col-9 col-md-10 mb-3">
                  ¿Desea contactar con el Colegio de Abogados?
                </div>
                <div class="col-3 col-md-2 mb-3">
                  <Input
                    type="select"
                    id="contactLawSchool"
                    value={complainantGender.contactLawSchool ? 1 : 0}
                    on:change={(event) => {
                      complainantGender.contactLawSchool = Boolean(
                        select_value(event.target)
                      );
                      console.log(event.target);
                    }}
                  >
                    <option value={1}>Si</option>
                    <option value={0}>No</option>
                  </Input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </TabPane>
      <TabPane tabId="5" tab="Sit. Familiar 2">
        <div class="mt-3" />
      </TabPane>
      <TabPane tabId="6" tab="Sit. Familiar 3">
        <div class="mt-3" />
      </TabPane>
      <TabPane tabId="7" tab="Medidas Cautelares 1">
        <div class="mt-3" />
      </TabPane>
      <TabPane tabId="8" tab="Medidas Cautelares 2">
        <div class="mt-3" />
      </TabPane>
      <TabPane tabId="9" tab="Asistencia Médica">
        <div class="mt-3" />
      </TabPane>
      <TabPane tabId="10" tab="Bienes Patrim.">
        <div class="mt-3" />
      </TabPane>
        <!-- <TabPane tabId="dataVehicle" tab="Datos del Vehículo">
          <div class="row">
            <div class="col-12 mb-3 mt-2">
              <Label for="matricula">Matricula</Label>
              <div class="input-group">
                <VehicleInput id={complainantGender?.vehicle_id} />
                <button
                  class="btn btn-secondary"
                  type="button"
                  id="complainantThirId"
                  name="complainantThirId"
                  on:click={() => { editVehicle = true; }}>
                  <Icon name="plus" />
                </button>
              </div>
            </div>

            {#if editVehicle}
              <AddVehicleList thirdId={complainantGender.complainantThirId} on:changeVehicle={(event) => changeVehicleEvent(event.detail)} />
            {/if}

            <div class="col-12 mb-3">
              <Label for="danios">Daños Vehiculo</Label>
              <Input
                type="textarea"
                rows={6}
                bind:value={complainantGender.vehicle_damage}
              />
            </div>
            <div class="col-12 col-sm-3">
              <Label>Matrícula Remolque</Label>
              <Input type="text" bind:value={complainantGender.trailer_registration} />
            </div>
          </div>

        </TabPane>
        <TabPane tabId="dataInfo1" tab="Alcoholemia">
          <div class="row mt-2">
            <div class="col-12 mb-2">
              <Label>Prueba alcoholemia</Label>
              <Input type="checkbox" label="Si" bind:checked={complainantGender.perform_alcoholemia} />
            </div>
            <div class="col-12 col-sm-6 mb-2">
              <Label>Hora - Toma 1</Label>
              <DateLocalInput bind:value={complainantGender.time_p_alcohol1}/>
            </div>
            <div class="col-12 col-sm-6 mb-2">
              <Label>Resultado - Toma 1</Label>
              <Input type="text" bind:value={complainantGender.result_p_alcohol1} />
            </div>
            <div class="col-12 col-sm-6 mb-2">
              <Label>Hora - Toma 2</Label>
              <DateLocalInput bind:value={complainantGender.time_p_alcohol2}/>
            </div>
            <div class="col-12 col-sm-6 mb-2">
              <Label>Resultado - Toma 2</Label>
              <Input type="text" bind:value={complainantGender.result_p_alcohol2} />
            </div>
            <div class="col-12 col-sm-3 mb-2">
              <Label>Excede 60</Label>
              <Input type="checkbox" label="Si" bind:checked={complainantGender.exceeds_060} />
            </div>
            <div class="col-12 col-sm-3 mb-2">
              <Label>Extracción de sangre</Label>
              <Input type="checkbox" label="Si" bind:checked={complainantGender.urine_blood_extraction} />
            </div>
            <div class="col-12 col-sm-3 mb-2">
              <Label>Bajo influencia</Label>
              <Input type="checkbox" label="Si" bind:checked={complainantGender.low_influence} />
            </div>
          </div>
        </TabPane>
        <TabPane tabId="dataInfo2" tab="Inf.Médico">
          <div class="row mt-2">
            <div class="col-12 col-sm-3 mb-2">
              <Label>Examen medico</Label>
              <Input type="checkbox" label="Si" bind:checked={complainantGender.medical_examination} />
            </div>
            <div class="col-12 mb-2">
              <Label>Historial Médico</Label>
              <Input
                type="textarea"
                rows={6}
                bind:value={complainantGender.medical_history}
              />
            </div>
            <div class="col-12 mb-2">
              <Label>Parte Facultativo</Label>
              <Input
                type="textarea"
                rows={6}
                bind:value={complainantGender.optional_part}
              />
            </div>
          </div>
        </TabPane>
        <TabPane tabId="dataInfo3" tab="Fisionomía">
          <div class="row mt-2">
            <div class="col-12 col-sm-6 mb-2">
              <Label>Defectos físicos</Label>
              <Input type="checkbox" label="Si" bind:checked={complainantGender.physical_defects} />
            </div>
            <div class="col-12 col-sm-6 mb-2">
              <Label>Pupilas</Label>
              <ParamSelect bind:paramSelectId={complainantGender.pupils_id} paramType="pupils" nothing={true} />
            </div>
            <div class="col-12 col-sm-6 mb-2">
              <Label>Rostro</Label>
              <ParamSelect bind:paramSelectId={complainantGender.ask_react_id} paramType="rostro" nothing={true} />
            </div>
            <div class="col-12 col-sm-6 mb-2">
              <Label>Comportamiento</Label>
              <ParamSelect bind:paramSelectId={complainantGender.behavior_id} paramType="behavior" nothing={true} />
            </div>
            <div class="col-12 col-sm-6 mb-2">
              <Label>Vestimenta</Label>
              <ParamSelect bind:paramSelectId={complainantGender.dress_id} paramType="dress" nothing={true} />
            </div>
            <div class="col-12 col-sm-6 mb-2">
              <Label>Aspecto</Label>
              <ParamSelect bind:paramSelectId={complainantGender.ask_react_id} paramType="rostro" nothing={true} />
            </div>
            <div class="col-12 col-sm-6 mb-2">
              <Label>Facciones</Label>
              <ParamSelect bind:paramSelectId={complainantGender.ask_react_id} paramType="rostro" nothing={true} />
            </div>
            <div class="col-12 col-sm-6 mb-2">
              <Label>Mirada</Label>
              <ParamSelect bind:paramSelectId={complainantGender.look_id} paramType="look" nothing={true} />
            </div>
            <div class="col-12 col-sm-6 mb-2">
              <Label>Movimientos</Label>
              <ParamSelect bind:paramSelectId={complainantGender.movements_id} paramType="movements" nothing={true} />
            </div>

            <div class="col-12 col-sm-6 mb-2">
              <Label>Otros Detalles</Label>
              <ParamSelect bind:paramSelectId={complainantGender.others_detalles_id} paramType="others_details" nothing={true} />
            </div>
            <div class="col-12 col-sm-6 mb-2">
              <Label>Constitución Física</Label>
              <ParamSelect bind:paramSelectId={complainantGender.physical_constitution_id} paramType="physical_constitution" nothing={true} />
            </div>
            <div class="col-12 col-sm-6 mb-2">
              <Label>Respiración</Label>
              <ParamSelect bind:paramSelectId={complainantGender.respiration_id} paramType="respiration" nothing={true} />
            </div>
            <div class="col-12 col-sm-6 mb-2">
              <Label>Voz</Label>
              <ParamSelect bind:paramSelectId={complainantGender.voice_id} paramType="voice" nothing={true} />
            </div>

          </div>
        </TabPane>
        <TabPane tabId="dataDriver1" tab="Abogacia">
          <div class="row mt-2">
            <div class="col-12 col-sm-3 mb-2">
              <Label>Informe administrativo</Label>
              <Input type="checkbox" label="Si" bind:checked={complainantGender.administrative_infection} />
            </div>
            <div class="col-12 col-sm-3 mb-2">
              <Label>Abogado</Label>
              <Input type="checkbox" label="Si" bind:checked={complainantGender.appoints_lawyer} />
            </div>
            <div class="col-12 col-sm-3 mb-2">
              <Label>De oficio</Label>
              <Input type="checkbox" label="Si" bind:checked={complainantGender.ex_officio} />
            </div>
            <div class="col-12 col-sm-3 mb-2">
              <Label>Aviso familiar</Label>
              <Input type="checkbox" label="Si" bind:checked={complainantGender.family_notice} />
            </div>
            <div class="col-12 col-sm-3 mb-2">
              <Label>Intérprete</Label>
              <Input type="checkbox" label="Si" bind:checked={complainantGender.interpreter} />
            </div>
            <div class="col-12 col-sm-3 mb-2">
              <Label>Quiere declarar</Label>
              <Input type="checkbox" label="Si" bind:checked={complainantGender.want_declare} />
            </div>
            <div class="col-12 col-sm-3 mb-2">
              <Label>Quiere Denunciar</Label>
              <Input type="checkbox" label="Si" bind:checked={complainantGender.complaint} />
            </div>
            <div class="col-12">
              <Label>Boletin</Label>
              <Input
                type="textarea"
                rows={6}
                bind:value={complainantGender.num_boletin}
              />
            </div>
          </div>
        </TabPane> -->
      {/if}

    </TabContent>
    <!-- <DiligenceComplainantTrafficData complainantGender={complainantGender} diligenceId={diligenceId} /> -->

  </ModalBody>
  <ModalFooter>
    <button class="btn btn-success" type="button" on:click={saveComplainantTraffic}>Guardar</button>
  </ModalFooter>
</Modal>

